const STORAGE_KEY = 'zendeskLoginSubdomain';

export const getStoredZendeskSubdomain = (): string => {
  try {
    return localStorage.getItem(STORAGE_KEY) ?? '';
  } catch {
    return '';
  }
};

export const setStoredZendeskSubdomain = (value: string): void => {
  const trimmed = value.trim();
  try {
    if (trimmed) {
      localStorage.setItem(STORAGE_KEY, trimmed);
    } else {
      localStorage.removeItem(STORAGE_KEY);
    }
  } catch {
    // Storage may be unavailable (private mode, ITP); silently no-op.
  }
};
